var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPopupErrorNewVersion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3062_9661)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45.4998,
    cy: 45.5001,
    r: 31.1878,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.4999 -0.0712891C20.3492 -0.0712891 -0.0712891 20.3492 -0.0712891 45.4999C-0.0712891 70.6507 20.3492 91.0711 45.4999 91.0711C70.6507 91.0711 91.0711 70.6507 91.0711 45.4999C91.0711 20.3492 70.6507 -0.0712891 45.4999 -0.0712891ZM39.0516 45.4999L26.1641 32.6078C24.3868 30.8305 24.3868 27.9413 26.1641 26.1641C27.9413 24.3868 30.8305 24.3868 32.6078 26.1641L45.4999 39.0561L58.3875 26.1641C60.1647 24.3868 63.0539 24.3868 64.8312 26.1641C66.6131 27.9413 66.6131 30.8305 64.8312 32.6078L51.9437 45.4999L64.8312 58.3875C66.6131 60.1647 66.6131 63.0539 64.8312 64.8312C63.0539 66.6131 60.1647 66.6131 58.3875 64.8312L45.4999 51.9437L32.6078 64.8312C30.8305 66.6131 27.9413 66.6131 26.1641 64.8312C24.3868 63.0539 24.3868 60.1647 26.1641 58.3875L39.0516 45.4999Z",
    fill: "url(#paint0_linear_3062_9661)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3062_9661",
    x1: 45.4999,
    y1: -0.0712891,
    x2: 45.4999,
    y2: 91.0711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE2142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB0B0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3062_9661"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 91,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPopupErrorNewVersion);
export default __webpack_public_path__ + "static/media/icon_popup_error_new_version.c91617089a95aad342703153860a094b.svg";
export { ForwardRef as ReactComponent };